import React, { useEffect } from "react";
import { Route, useHistory, useLocation } from "react-router-dom";
import { Content } from "./Content";
import { getConfig } from "../../../i18n";

export function ContentRoute({
  children,
  component,
  render,
  ROUTES = {},
  ROUTE_DEFAULT = "/",
  ...props
}) {
  const { role } = getConfig();
  const history = useHistory();

  const key = Object.keys(ROUTES).find((r) => ROUTES[r].path === props.path);

  return (
    <Route {...props}>
      {(routeProps) => {
        if (key) {
          if (!ROUTES[key].accepts.includes(role)) {
            history.push("/error/403");
            return null;
          }
        }

        if (typeof children === "function") {
          return <Content>{children(routeProps)}</Content>;
        }

        if (!routeProps.match) {
          return null;
        }

        if (children) {
          return <Content>{children}</Content>;
        }

        if (component) {
          return (
            <Content>{React.createElement(component, routeProps)}</Content>
          );
        }

        if (render) {
          return <Content>{render(routeProps)}</Content>;
        }

        return null;
      }}
    </Route>
  );
}
